/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pearl_Tall_Lark_DrawInputs */

const en_pearl_tall_lark_draw = /** @type {(inputs: Pearl_Tall_Lark_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add custom topic`)
};

const de_pearl_tall_lark_draw = /** @type {(inputs: Pearl_Tall_Lark_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefiniertes Thema hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add custom topic" |
*
* @param {Pearl_Tall_Lark_DrawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pearl_tall_lark_draw = /** @type {((inputs?: Pearl_Tall_Lark_DrawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pearl_Tall_Lark_DrawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pearl_tall_lark_draw(inputs)
	return de_pearl_tall_lark_draw(inputs)
});